import { Empty } from '../Common/Empty'
import type { PostType, DraftPreview, ProfilePreview } from '../types'
import { LinkedInPost } from './components/Post'
import { PostPreviewCard } from '../Common/styles'

import styles from './LinkedInPreview.module.css'

import type { JSX } from 'react'

export const LinkedInPreview = ({
  draft,
  profile,
}: {
  draft: DraftPreview
  profile: ProfilePreview
}): JSX.Element => {
  if (draft.isEmpty) return <Empty />

  const draftLinkedIn: PostType = {
    content: {
      ...draft,
      text: draft.text,
    },
  }

  return (
    <PostPreviewCard
      className={styles.linkedInPreview}
      data-testid="linkedin-preview"
    >
      <LinkedInPost content={draftLinkedIn.content} profile={profile} />
    </PostPreviewCard>
  )
}
